/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ProcessDocumentService extends HttpHandlerService {

        constructor($http: ng.IHttpService, private $q: ng.IQService) {
            super($http);
        }

        public updateProcessDocuments(
            process: Wars.Domain.Model.Dtos.ProcessDto,
            newDocuments: Wars.Domain.Model.Dtos.DocumentDto[],
            oldDocIds: string[]): ng.IPromise<any>
        {
            var defer = this.$q.defer();

            var newDocIds = Enumerable.from(newDocuments).select(i => i.id).toArray();
            if (process.documents && process.documents.length > 0) {
                // Remove old and any updated documents from current list
                process.documents = Enumerable.from(process.documents)
                    .where(i => (!oldDocIds || oldDocIds.indexOf(i.id) === -1) && (!newDocIds || newDocIds.indexOf(i.id) === -1))
                    .toArray();
            }

            if (newDocuments && newDocuments.length > 0) {
                process.documents = process.documents.concat(newDocuments);
            }
            this.updateManageDocumentSections(process).then(() => {
                defer.resolve();
            });

            return defer.promise;
        }

        public getDocumentById(process: Wars.Domain.Model.Dtos.ProcessDto, id: string) : Wars.Domain.Model.Dtos.DocumentDto {
            if (process && process.documents) {
                var match = Enumerable.from(process.documents).singleOrDefault(i => i.id === id);
                if (match) return match;
            }
            return undefined;
        }

        public updateManageDocumentSections(process: Wars.Domain.Model.Dtos.ProcessDto): ng.IPromise<any> {
            var defer = this.$q.defer();

            this.handlerUrl = "api/Process/" + process.id +"/DocumentManageSections";
            var params: any = {};

            this.useGetHandler(params).then((processDto: Wars.Domain.Model.Dtos.ProcessDto) => {
                process.documentSections = processDto.documentSections;
                defer.resolve();
            });

            return defer.promise;
        }
    }
}

warsApp.registerService("ProcessDocumentService", ["$http", "$q"]);